import { ApiClient } from "@/services/ApiService";

export default {
  async deleteAnswer(id) {
    const response = await ApiClient.delete(`answer/${id}`);
    return response.data;
  },
  async getAnswers() {
    const response = await ApiClient.get(`answer`);
    return response.data;
  },
  async getAnswer(id) {
    const response = await ApiClient.get(`answer/${id}`);
    return response.data;
  },
  async getAnswersByQuestionId(id) {
    const response = await ApiClient.get(`answer/question/${id}`);
    return response.data;
  },
  async getCorrectByQuestionId(id) {
    const response = await ApiClient.get(`answer/question-correct/${id}`);
    return response.data;
  },
  async postAnswer(answer) {
    const response = await ApiClient.post(`answer`, answer);
    return response.data;
  },
  async putAnswer(answer) {
    const response = await ApiClient.put(`answer/${answer.answerId}`, answer);
    return response.data;
  }
};
